import { Box, Link, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import UserCard from "./UserCard";
import PeriodScoreDistribution from "./NComponent/pms/PeriodScoreDistribution";
import EwModal from "./MComponent/Modal/Modal";
import { getDateFromEpoch, getUserId } from "./Utils/Common/Library";
import { calculateAssessmentScore } from "./NComponent/pms/Dimension/Modals/ScorePreview";
import { WorkflowProcesser } from "./NComponent/pms/Dimension/WorkflowProcesser";

const getStatus = (workflow) => {
  const processor = new WorkflowProcesser(workflow);
  if (workflow.WorkflowStatus === "C") return "Assessment Closed";
  const pendingStep = processor.getCurrentStepData();
  if (!pendingStep || !pendingStep.StepOwnerType)
    return "Action not due with anyone";
  switch (pendingStep.StepOwnerType) {
    case "LM":
      return "Appraiser Assessment Due";
    case "FM":
      return "Reviewer Assessment Due";
    case "OR":
      return "Moderator Action Due";
    case "SU":
      return "Appraisee Acceptance Due";
    case "TU":
      return "Assessment Initiated";
    default:
      return "Action not due with anyone";
  }
};

const getData = (DimensionPeriodData, epp) => {
  const EPP = epp;
  const Dimension = EPP.Dimensions.find(
    (d) => d.DimensionID === DimensionPeriodData.DimensionID
  );
  let filteredAssesment = DimensionPeriodData.ParameterAssessments.filter(
    (item) => item
  );

  const DimensionPhase = filteredAssesment.length > 0 ? "A" : "G";

  let Users = null;
  let AggregateScores = null;
  if (DimensionPhase === "G") {
    Users = DimensionPeriodData.Workflow?.WorkflowSteps?.filter(
      (step) => step.StepID !== "000"
    ).map((step) => ({
      label: step.StepOwnerLabel,
      value: step.StepOwnerUserIDs[0],
      order:
        step.StepOwnerLabel === "Appraisee"
          ? 0
          : step.StepOwnerLabel === "Appraiser"
          ? 1
          : 2,
    }));
  } else {
    let LatestAssessment = DimensionPeriodData.ParameterAssessments?.find(
      (assessment) => {
        let temp = assessment || {};
        return temp.Workflow && temp.Workflow.WorkflowStatus !== "C";
      }
    );
    if (!LatestAssessment) {
      console.log(
        (
          DimensionPeriodData.ParameterAssessments[
            DimensionPeriodData.ParameterAssessments?.length - 1
          ] || {}
        ).Workflow?.WorkflowSteps || [],
        "USSSER _ARRAY"
      );
      Users = (
        (
          DimensionPeriodData.ParameterAssessments[
            DimensionPeriodData.ParameterAssessments?.length - 1
          ] || {}
        ).Workflow?.WorkflowSteps || []
      )
        .filter((step) => step.StepID !== "000")
        .map((step) => ({
          label: step.StepOwnerLabel,
          value: step.StepOwnerUserIDs[0],
          order:
            step.StepOwnerLabel === "Appraisee"
              ? 0
              : step.StepOwnerLabel === "Appraiser"
              ? 1
              : 2,
        }));
      AggregateScores = (
        DimensionPeriodData.ParameterAssessments[
          DimensionPeriodData.ParameterAssessments?.length - 1
        ].Data.PeriodAggregateScore || []
      )
        .filter((score) => score.ActorType !== "Appraisee")
        .filter((score) => score.AggregateScore);
    } else {
      console.log(LatestAssessment.Workflow?.WorkflowSteps, "USSSER_ARRAY");
      Users = LatestAssessment.Workflow?.WorkflowSteps?.filter(
        (step) => step.StepID !== "000"
      ).map((step) => ({
        label: step.StepOwnerLabel,
        value: step.StepOwnerUserIDs[0],
        order:
          step.StepOwnerLabel === "Appraisee"
            ? 0
            : step.StepOwnerLabel === "Appraiser"
            ? 1
            : 2,
      }));
      AggregateScores = (LatestAssessment.Data.PeriodAggregateScore || [])
        .filter((score) => score.ActorType !== "Appraisee")
        .filter((score) => score.AggregateScore);
    }
  }
  return {
    WorkflowUsers: (Users || []).sort((a, b) => {
      return a.order > b.order ? 1 : b.order > a.order ? -1 : 0;
    }),
    ScoreDistributionProps: {
      DimensionID: DimensionPeriodData.DimensionID,
      UserID: getUserId(),
      Visibility:
        DimensionPhase === "A" && Dimension.AppraiserID === getUserId(),
    },
    AggregateScores:
      getUserId() === epp.AppraiseeUserID ? undefined : AggregateScores,
  };
};

function SidePanel({
  ViewName,
  PlanStartDate,
  PlanEndDate,
  PlanStage,
  DimensionPeriodData,
  DimensionPhase,
  annualAssessment,
  Users,
  planStore,
}) {
  const [modal, setModal] = useState(null);

  let { WorkflowUsers, ScoreDistributionProps } = useMemo(() => {
    if (!DimensionPeriodData) return {};
    return getData(DimensionPeriodData, planStore?.EPP);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DimensionPeriodData]);

  if (!ViewName) ViewName = "Unnamed View";
  if (!WorkflowUsers) WorkflowUsers = [...(Users || [])];
  if (!ScoreDistributionProps)
    ScoreDistributionProps = {
      DimensionID: "",
      UserID: "",
      Visibility: false,
    };

  const { DimensionID, UserID, Visibility } = ScoreDistributionProps;

  function convertDateToString(initDate) {
    if (!initDate) return "Not Defined";
    return getDateFromEpoch({ epoch: initDate, returnNthString: true });
  }

  const dimensionRoundingMap = {};
  (planStore?.MPP?.Dimension || []).forEach((d) => {
    dimensionRoundingMap[d.DimensionID] = {
      ScoreRounding: d.ScoreRounding,
      RoundingValue: d.RoundingValue,
      PlanDimensionWeight: d.PlanDimensionWeight,
    };
  });

  const annualAssessmentliveScore = annualAssessment?.Workflow
    ? calculateAssessmentScore(
        annualAssessment,
        dimensionRoundingMap,
        DimensionPeriodData?.DimensionName?.includes("Core") ? true : false
      )
    : 0;

  const { Workflow: goalSettingWorkflow = {} } = DimensionPeriodData || {};

  let planStatus = "Goal Setting not Started";
  try {
    if (!goalSettingWorkflow || !goalSettingWorkflow.WorkflowStatus) {
      planStatus = "Goal Setting not Started";
    } else if (goalSettingWorkflow.WorkflowStatus === "I") {
      planStatus = "Goals Setting Pending";
    } else if (
      goalSettingWorkflow.WorkflowStatus === "C" &&
      (!annualAssessment || !annualAssessment.Workflow)
    ) {
      planStatus = "Goal Setting Completed";
    } else if (
      goalSettingWorkflow.WorkflowStatus === "C" &&
      annualAssessment &&
      annualAssessment.Workflow
    ) {
      planStatus = PlanStage || getStatus(annualAssessment.Workflow);
    } else {
      planStatus = "Assessment Closed";
    }
  } catch (e) {
    planStatus = "Goal Setting not Started";
  }

  return (
    <Stack className="scroll" sx={{ height: "85vh" }} rowGap={"1rem"}>
      <Stack rowGap={"0.5rem"}>
        <Typography variant="h2" color={"primary"}>
          {ViewName}
        </Typography>
        <Box display={"flex"} gap={"0.4rem"}>
          <Typography variant="subtitle2" sx={{ color: "#00000080" }}>
            Plan Period:{" "}
          </Typography>
          <Box display={"flex"} gap={"0.5em"}>
            <Typography variant="subtitle2">
              {convertDateToString(PlanStartDate)}
            </Typography>{" "}
            <Typography variant="subtitle2">to</Typography>{" "}
            <Typography variant="subtitle2">
              {convertDateToString(PlanEndDate)}
            </Typography>
          </Box>
        </Box>
        {planStatus && (
          <Box display={"flex"} gap={"0.4em"}>
            <Typography variant="subtitle2" sx={{ color: "#00000080" }}>
              Plan Stage:
            </Typography>
            <Typography variant="subtitle2">{planStatus}</Typography>
          </Box>
        )}
        {DimensionPhase === "A" &&
          annualAssessment?.Workflow?.WorkflowStatus !== "C" &&
          annualAssessmentliveScore !== null && (
            <Box display={"flex"} gap={"0.4em"}>
              <Typography variant="subtitle2" sx={{ color: "#00000080" }}>
                {DimensionPeriodData?.DimensionName || ""} Score:
              </Typography>
              <Typography variant="subtitle2">
                {annualAssessmentliveScore}
              </Typography>
            </Box>
          )}
        {Visibility && (
          <Link
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setModal({
                Component: PeriodScoreDistribution,
                props: {
                  DimensionID,
                  UserID,
                },
              });
            }}
          >
            <Typography variant="subtitle2">View Score Distribution</Typography>
          </Link>
        )}
      </Stack>
      <Stack
        rowGap={"1rem"}
        maxHeight={"70%"}
        className="invisble-scroll"
        padding={"0.5rem"}
      >
        {WorkflowUsers.map((user) => (
          <UserCard role={user.label} UserID={user.value} key={user.value} />
        ))}
      </Stack>
      {modal && (
        <EwModal
          onClose={() => {
            setModal(null);
          }}
          open={modal}
        >
          <modal.Component {...modal.props} />
        </EwModal>
      )}
    </Stack>
  );
}

export default SidePanel;
